import { RoleTypes } from "models/role-types.model";
import { IconType } from "react-icons";
import {
  RiHome2Fill,
  RiMailFill,
  RiPagesFill,
  RiUserFill
} from "react-icons/ri";

export interface MenuItemProps {
  icon: IconType;
  name: string;
  description: string;
  to: string;
  roleTypes?: RoleTypes[];
  subMenu?: MenuItemProps[];
}

export const menu: { [key: string]: MenuItemProps } = {
  INICIO: {
    icon: RiHome2Fill,
    name: "Início",
    description: "Página Inicial",
    to: "/",
    roleTypes: ['Administrador', 'Colaborador']
  },
  POSTS: {
    name: "Publicações",
    icon: RiPagesFill,
    description: "Dados descritivos que serão apresentados no aplicativo",
    to: "/posts",
    roleTypes: ['Administrador', 'Colaborador']
  },
  COMPLAINTS: {
    name: "Manifestações",
    icon: RiMailFill,
    description: "Manifestações criadas pela população através do aplicativo.",
    to: "/complaints",
    roleTypes: ['Administrador', 'Colaborador']
  },
  USERS: {
    name: "Usuários",
    icon: RiUserFill,
    description: "Gerenciamento de perfis de usuários.",
    to: "/users",
    roleTypes: ['Administrador']
  },
};

export function useMenu(roleTypes: RoleTypes[]) {
  const filterMenu = (s: string) => {
    const result: MenuItemProps[] = [];
    Object.values(menu).forEach(function iter(o: MenuItemProps) {
      let isAllowed = roleTypes.length > 0 ? false : true;

      const userRoles = roleTypes.map(x => x.toUpperCase());
      const requiredRoles = o.roleTypes?.map(x => x.toUpperCase()) ?? [];

      if (userRoles.some(x => requiredRoles.includes(x))) {
        isAllowed = true;
      }

      if (
        (o.name.toUpperCase().includes(s.toUpperCase()) ||
          o.description.toUpperCase().includes(s.toUpperCase())) &&
        isAllowed
      ) {
        result.push(o);
      }
      if (s != "") {
        (o.subMenu || []).forEach(iter);
      }
    });
    return result;
  };

  return { filterMenu };
}
